import moment, {Moment} from "moment-timezone";
import {Transform, Type} from "class-transformer";

export interface SignedLink {
  expires_at: Moment; // DateTime
  url: URL;
}

export class SignedLinkImpl implements SignedLink {
  @Type(() => moment)
  @Transform(({value}) => value ? moment.utc(value) : value, {toClassOnly: true})
  @Transform(({value}) => value ? value.toJSON() : value, {toPlainOnly: true})
  expires_at: Moment;
  @Type(() => URL)
  @Transform(({value}) => value ? new URL(value) : value, {toClassOnly: true})
  @Transform(({value}) => value ? value.toString() : value, {toPlainOnly: true})
  url: URL;
}
